// import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
//
// import {cleanerService} from "../../services/cleaner.service";
//
// const initialState = {
//     cleaner: {},
//     status: '',
//     error: {}
// }
//
//
// const getById = createAsyncThunk(
//     'cleanerDetailsSlice/getById',
//     async ({id}) => {
//         // try {
//         //     const {data: cleaners} = await cleanerService.getAll();
//         //     const cleaner = cleaners.find((cleaner) => cleaner.user.id = id);
//         //
//         //     return cleaner;
//         // } catch (error) {
//         //     throw error;
//         // }
//         try {
//             const {data} = await cleanerService.getById(id);
//
//             return data;
//         } catch (error) {
//             throw error;
//         }
//     }
// );
//
// const cleanerDetailsSlice = createSlice({
//     name: 'cleanerDetailsSlice',
//     initialState,
//     reducers: {
//         setError: (state, action) => {
//             state.error = action.payload;
//         }
//     },
//     extraReducers: (builder) => builder
//         .addCase(getById.fulfilled, (state, action) => {
//             state.cleaner = action.payload;
//
//             state.status = 'success';
//         })
//         .addCase(getById.pending, (state, action) => {
//             state.status = 'loading';
//         })
// });
//
// const {actions, reducer: cleanerDetailsReducer} = cleanerDetailsSlice;
//
// const cleanerDetailsActions = {
//     ...actions,
//     getById,
// }
//
// export {
//     cleanerDetailsActions,
//     cleanerDetailsReducer,
// }


import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {cleanerService} from "../../services/cleaner.service";

const initialState = {
    cleaner: {},
    status: '',
    error: {}
}


const getById = createAsyncThunk(
    'cleanerDetailsSlice/getById',
    async ({id}) => {
        // try {
        //     const {data: cleaners} = await cleanerService.getAll();
        //     const cleaner = cleaners.find((cleaner) => cleaner.user.id = id);
        //
        //     return cleaner;
        // } catch (error) {
        //     throw error;
        // }
        try {
            const {data} = await cleanerService.getById(id);

            return data;
        } catch (error) {
            throw error;
        }
    }
);

const cleanerDetailsSlice = createSlice({
    name: 'cleanerDetailsSlice',
    initialState,
    reducers: {
        setError: (state, action) => {
            state.error = action.payload;
        },
        setCleaner: (state, action) => {
            state.cleaner = action.payload;
        }
    },
    extraReducers: (builder) => builder
        .addCase(getById.fulfilled, (state, action) => {
            state.cleaner = action.payload;

            state.status = 'success';
        })
        .addCase(getById.pending, (state, action) => {
            state.status = 'loading';
        })
});

const {actions, reducer: cleanerDetailsReducer} = cleanerDetailsSlice;

const cleanerDetailsActions = {
    ...actions,
    getById,
}

export {
    cleanerDetailsActions,
    cleanerDetailsReducer,
}